/* eslint-disable no-unused-vars */
/* eslint-disable eqeqeq */
import { FieldArray, Formik } from "formik";
import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { getTrustDetail } from "./TrustHelper";
import { API, fileUpload } from "../../config";
import { useBankList, useStateList, SuburbList } from "../../lib/OptionsAPI";
import {
  formatBSBNumber,
  formatedPostalCode,
  MaxLimit,
  padWithLeadingZeros,
} from "../../lib/Misc";
import { AddTrustSchema } from "../../lib/Validation";
// import Spin from "../../components/Spin";
import { Button } from "../../components/ui/button";
import { cn } from "../../lib/utils";
import CustomLabelText from "../../components/CustomLabelText";
import { Label } from "../../components/ui/label";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuTrigger,
  DropdownMenuItem,
} from "../../components/ui/dropdown-menu";
import { Loader2, LucideInfo, Plus, Trash2 } from "lucide-react";
import { Input } from "../../components/ui/input";
import { CardTitle } from "../../components/ui/card";
import SearchSelect from "../../components/SearchSelect";
import PostalCodeInput from "../../components/PostalCodeInput";
import { PhoneInput } from "../../components/ui/phone-input";
import ProfileUpload from "../../components/ProfileUpload";
import { NumericFormat } from "react-number-format";
import ReactInputMask from "react-input-mask";
import SuburbSelect from "../../components/SuburbSelect";
import Spin from "../../components/Spin";
import TrustSelect from "../../components/TrustSelect";
import { useTrust } from "../../lib/context/TrustContext";
import { useOrganization } from "../../lib/context/OrganisationContext";
import { Switch } from "../../components/ui/switch";
import { InvoiceModuleConditon } from "../../lib/PermissionConditions";
import { DateInputPicker } from "../../components/DateInputPicker";
import moment from "moment";

const AddEditTrust = ({
  edit,
  trustID,
  toggleShowAddEditTrust,
  editByTrust = false,
  fetchTrusts,
  orgId,
  tab = false,
}) => {
  const { id } = useParams();
  const [trustData, setTrustData] = useState();
  // eslint-disable-next-line no-unused-vars
  const [loading, setLoading] = useState(false);
  const [suburbLoading, setSuburbLoading] = useState(false);
  const [suburbListing, setSuburbListing] = useState([]);
  const [suburbList, setSuburbList] = useState([]);
  const trustId = trustID ? trustID : id;

  const [trustLoading, setTrustLoading] = useState(false);
  const [trustListing, setTrustListing] = useState([]);
  const [trustList, setTrustList] = useState([]);
  const { organizationData } = useOrganization();
  const { fetchTrustList, updateTrustData } = useTrust();

  const premiumTypeList = [
    { label: "%", value: "1" },
    { label: "Flat Amount", value: "0" },
  ];

  // const formValues = useRef();

  async function fetchData() {
    try {
      setLoading(true);
      const data = await getTrustDetail(trustId);
      if (data?.state_id ? data?.state_id : false) {
        FetchSuburbList(data?.state_id ? data?.state_id : "", "");
        if (data?.suburb_id ? data?.suburb_id : false) {
          setSuburbList([
            data?.suburb
              ? {
                  ...data?.suburb,
                  value: data?.suburb.id,
                  label: data?.suburb.name,
                }
              : {},
          ]);
        }
      }
      setTrustData(data);
      setLoading(false);
    } catch (e) {
      setTrustData(null);
    }
  }
  useEffect(() => {
    if (edit) {
      fetchData();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [trustId]);

  // Submit Form
  const handleFormSubmit = async (value) => {
    const formData = new FormData();

    value.phone = value?.phone ? `${value?.phone}`.replace(/ /g, "") : "";
    value.mobile = value?.mobile ? `${value?.mobile}`.replace(/ /g, "") : "";
    value.opening_balance = Number(
      `${value?.opening_balance}`.replace(/,/g, "")
    );

    formData.append("organization_id", orgId ? orgId : "");
    formData.append("first_name", value?.first_name ? value?.first_name : "");
    formData.append("last_name", value?.last_name ? value?.last_name : "");
    formData.append("mobile", value?.mobile != null ? value?.mobile : "");
    formData.append(
      "business_name",
      value?.business_name ? value?.business_name : ""
    );

    formData.append("email", value?.email ? value?.email : "");
    formData.append("street", value?.street ? value?.street : "");
    formData.append("state_id", value?.state_id ? value?.state_id : "");
    formData.append("suburb_id", value?.suburb_id ? value?.suburb_id : "");
    formData.append(
      "postal_code",
      value?.postal_code ? value?.postal_code : ""
    );
    value?.profile_pic &&
      formData.append(
        "profile_pic",
        value?.profile_pic ? value?.profile_pic : ""
      );
    value?.logo && formData.append("logo", value?.logo ? value?.logo : "");
    formData.append(
      "account_name",
      value?.account_name ? value?.account_name : ""
    );
    formData.append("bsb", value?.bsb ? formatBSBNumber(value?.bsb) : "");
    formData.append(
      "account_number",
      value?.account_number ? value?.account_number : ""
    );
    formData.append(
      "opening_balance",
      value?.opening_balance ? value?.opening_balance : 0
    );
    formData.append("trust_id", value?.trust_id ? value?.trust_id : "");

    formData.append("apca_id", value?.apca_id ? value?.apca_id : "");

    formData.append("bank_id", value?.bank_id ? value?.bank_id : "");

    formData.append(
      "transaction_start_date",
      value?.transaction_start_date
        ? moment(value?.transaction_start_date).format("DD-MM-YYYY")
        : ""
    );

    // ✅ Append simple fields
    formData.append("is_premium", value.is_premium ? "1" : "0");

    // ✅ Append array (premiums)
    value.premiums.forEach((item, index) => {
      formData.append(`premiums[${index}][code]`, item.code || "");
      formData.append(
        `premiums[${index}][premium_type]`,
        item.premium_type || ""
      );
      formData.append(
        `premiums[${index}][amount]`,
        Number(`${item.amount}`.replace(/,/g, "")) || ""
      );
    });

    // ✅ Append simple fields
    formData.append("is_commission", value.is_commission ? "1" : "0");

    // ✅ Append array (commissions)
    value.commissions.forEach((item, index) => {
      formData.append(`commissions[${index}][code]`, item.code || "");
      formData.append(
        `commissions[${index}][commission_type]`,
        item.commission_type || ""
      );
      formData.append(
        `commissions[${index}][amount]`,
        Number(`${item.amount}`.replace(/,/g, "")) || ""
      );
    });

    if (trustId) {
      formData.append("_method", "put");
    }
    try {
      setLoading(true);
      const { data } = await fileUpload(
        `${API.TRUST_ADD}${trustId ? `/${trustId}` : ""}`,
        formData
      );
      setLoading(false);

      if (data) {
        updateTrustData(data?.data);
        // editByTrust &&
        //   localStorage.setItem(
        //     "BusinessName",
        //     value?.business_name ? value?.business_name : ""
        //   );
        toggleShowAddEditTrust && toggleShowAddEditTrust();
        fetchTrusts && fetchTrusts();
        if (
          organizationData?.organizationId &&
          organizationData?.organizationId !== undefined
        ) {
          fetchTrustList(organizationData?.organizationId);
        }
      }
      return data?.data;
    } catch (error) {
      setTrustData(value);
      setLoading(false);
    }
  };

  // State
  // eslint-disable-next-line no-unused-vars
  const { stateLoading, stateList = [] } = useStateList();
  const stateListing = stateList?.map((item) => {
    const { id: value, name, short_name, ...rest } = item;
    return { label: name + ` (${short_name})`, value, ...rest };
  });
  const state = stateListing?.find(
    (item) => item?.value === (trustData?.state_id ? trustData?.state_id : "")
  )?.value;

  // eslint-disable-next-line no-unused-vars
  const { bankLoading, bankList = [] } = useBankList();
  const bankListing = bankList ? bankList : [];
  const projectBank = bankListing?.find(
    (item) => item?.value === trustData?.bank_id
  )?.value;

  const FetchSuburbList = async (state_id) => {
    await SuburbList(state_id, 1, setSuburbLoading, setSuburbList, true);
  };

  useEffect(() => {
    if (suburbList) {
      let suburbTempListing = suburbList?.map((item) => ({
        ...item,
        value: item.id,
        label: item.name,
      }));
      setSuburbListing(suburbTempListing || []);
    } else {
      setSuburbListing([]);
    }
  }, [suburbList]);

  useEffect(() => {
    if (trustList) {
      let trustTempListing = trustList?.map((item) => ({
        ...item,
        value: item.id,
        label: `${
          item?.business_name
            ? item?.business_name
            : item?.first_name
              ? item?.first_name + " " + item?.last_name
              : item?.last_name
        } ${item?.account_number ? `(${item?.account_number})` : ""}`,
      }));
      let finalList = trustTempListing?.filter(
        (item) => item?.id !== trustID && item?.id !== "new"
      );
      setTrustListing(finalList || []);
    } else {
      setTrustListing([]);
    }
  }, [trustList, trustID]);

  return (
    <Formik
      initialValues={{
        profile_pic: trustData?.profile_pic ? trustData?.profile_pic : "",
        logo: trustData?.logo ? trustData?.logo : "",
        business_name: trustData?.business_name ? trustData?.business_name : "",
        first_name: trustData?.first_name ? trustData?.first_name : "",
        last_name: trustData?.last_name ? trustData?.last_name : "",
        mobile: trustData?.mobile
          ? trustData?.mobile[0] === "+"
            ? trustData?.mobile
            : `+${trustData?.mobile}`
          : "",
        email: trustData?.email ? trustData?.email : "",
        street: trustData?.street ? trustData?.street : "",
        state_id: state,
        suburb_id: trustData?.suburb_id,
        postal_code: trustData?.postal_code
          ? formatedPostalCode(trustData?.postal_code)
          : "",
        trust_id: trustData?.trust_id ? trustData?.trust_id : "",
        account_name: trustData?.account_name ? trustData?.account_name : "",
        bsb: trustData?.bsb ? trustData?.bsb : "",
        account_number: trustData?.account_number
          ? trustData?.account_number
          : "",
        opening_balance: trustData?.opening_balance
          ? trustData?.opening_balance
          : 0,
        transaction_start_date: trustData?.transaction_start_date
          ? moment(trustData?.transaction_start_date)
          : "",

        bank_id: projectBank ? projectBank : "",
        apca_id: trustData?.apca_id
          ? padWithLeadingZeros(trustData?.apca_id, 6)
          : "",
        is_premium: trustData?.is_premium == "1" ? true : false,
        is_commission: trustData?.is_commission == "1" ? true : false,
        premiums:
          trustData?.premiums?.length > 0 && trustData?.premiums?.length
            ? trustData?.premiums
            : [],

        commissions:
          trustData?.commissions?.length > 0 && trustData?.commissions?.length
            ? trustData?.commissions
            : [],
      }}
      enableReinitialize
      onSubmit={handleFormSubmit}
      validateOnBlur={true}
      validateOnChange={true}
      validationSchema={AddTrustSchema}
    >
      {({
        values,
        errors,
        handleChange,
        handleBlur,
        handleSubmit,
        setFieldValue,
        isValid,
      }) => (
        <>
          {loading && <Spin expand={true} fullscreen={true} />}
          <form
            onSubmit={handleSubmit}
            noValidate
            className="entry-section md:m-0 m-5"
          >
            <div
              className={`form-box overflow-hidden overflow-y-auto ${
                tab ? "max-h-[69vh]" : "max-h-[80vh]"
              } p-4 border rounded-lg`}
            >
              <div>
                <ProfileUpload
                  path={values?.profile_pic}
                  pathData={values?.business_name?.charAt(0)}
                  setFieldValue={setFieldValue}
                  keyName={"profile_pic"}
                  popupType={tab ? "trusts" : ""}
                />
              </div>
              <div className="grid gap-4">
                <CardTitle className="text-md mt-5">Trust Details</CardTitle>
                <div className="grid lg:grid-cols-2 grid-cols-1 gap-4">
                  <div className="grid md:grid-cols-2 gap-4">
                    <div className="grid gap-2">
                      <Label htmlFor="business_name">
                        <CustomLabelText
                          required={true}
                          labelText="Trust Name"
                          errorField={errors?.business_name}
                        />
                      </Label>
                      <Input
                        id="business_name"
                        type="text"
                        name="business_name"
                        value={
                          values?.business_name ? values?.business_name : ""
                        }
                        onChange={handleChange}
                        onBlur={handleBlur}
                        autoComplete="off"
                        onKeyPress={(e) => {
                          e.which === 13 && e.preventDefault();
                        }}
                        className={
                          errors?.business_name &&
                          `focus-visible:ring-red-500 border-red-500`
                        }
                      />
                    </div>
                    <div className="grid gap-2">
                      <Label htmlFor="first_name">
                        <CustomLabelText
                          required={false}
                          labelText="First Name"
                          errorField={errors?.first_name}
                        />
                      </Label>
                      <Input
                        id="first_name"
                        type="text"
                        name="first_name"
                        value={values?.first_name ? values?.first_name : ""}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        autoComplete="off"
                        onKeyPress={(e) => {
                          e.which === 13 && e.preventDefault();
                        }}
                        className={
                          errors?.first_name &&
                          `focus-visible:ring-red-500 border-red-500`
                        }
                      />
                    </div>
                  </div>
                  <div className="grid md:grid-cols-2 gap-4">
                    <div className="grid gap-2">
                      <Label htmlFor="last_name">
                        <CustomLabelText
                          required={true}
                          labelText="Last Name"
                          errorField={errors?.last_name}
                        />
                      </Label>
                      <Input
                        id="last_name"
                        type="text"
                        name="last_name"
                        value={values?.last_name ? values?.last_name : ""}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        autoComplete="off"
                        onKeyPress={(e) => {
                          e.which === 13 && e.preventDefault();
                        }}
                        className={
                          errors?.last_name &&
                          `focus-visible:ring-red-500 border-red-500`
                        }
                      />
                    </div>
                    <div className="grid gap-2">
                      <Label htmlFor="mobile">
                        <CustomLabelText
                          required={false}
                          labelText="Phone/Mobile No."
                          errorField={errors?.mobile}
                        />
                      </Label>
                      <PhoneInput
                        onChange={(e) => {
                          setFieldValue("mobile", e);
                        }}
                        value={values?.mobile}
                        defaultValue={"+61"}
                        defaultCountry={"AU"}
                        minLength={15}
                        maxLength={15}
                        onBlur={handleBlur}
                        className={
                          errors?.mobile &&
                          `focus-visible:ring-red-500 border-red-500`
                        }
                      />
                    </div>
                  </div>
                  <div className="grid md:grid-cols-2 gap-4">
                    <div className="grid gap-2">
                      <Label htmlFor="email">
                        <CustomLabelText
                          required={false}
                          labelText="Email"
                          errorField={errors?.email}
                        />
                      </Label>
                      <Input
                        id="email"
                        type="email"
                        placeholder="m@example.com"
                        required
                        autoComplete="off"
                        name="email"
                        onChange={handleChange}
                        onBlur={handleBlur}
                        value={values?.email}
                        className={
                          errors?.email &&
                          `focus-visible:ring-red-500 border-red-500`
                        }
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div className="grid gap-4 pt-4">
                <CardTitle className="text-md">Address</CardTitle>
                <div className="grid lg:grid-cols-2 grid-cols-1 gap-4">
                  <div className="grid md:grid-cols-2 gap-4">
                    <div className="grid gap-1">
                      <Label htmlFor="street">
                        <CustomLabelText
                          required={true}
                          labelText="Street Address"
                          errorField={errors?.street}
                        />
                      </Label>
                      <Input
                        id="street"
                        placeholder="Enter Street"
                        required
                        name="street"
                        onChange={(e) => {
                          setFieldValue("street", e?.target?.value);
                        }}
                        onBlur={handleBlur}
                        value={values?.street}
                        className={
                          errors?.street &&
                          `focus-visible:ring-red-500 border-red-500`
                        }
                      />
                    </div>
                    <div className="grid gap-2">
                      <div className="min-w-0">
                        <Label htmlFor="state_id">
                          <CustomLabelText
                            required={true}
                            labelText="State"
                            errorField={errors?.state_id}
                          />
                        </Label>
                        <div className="relative mt-2">
                          <SearchSelect
                            frameworks={stateListing}
                            optionType={"State"}
                            clearable={true}
                            onClear={() => {
                              setFieldValue("state_id", "");
                              setFieldValue("suburb_id", "");
                              setSuburbList([]);
                            }}
                            handleSelect={(e) => {
                              setFieldValue("state_id", e);
                              setFieldValue("suburb_id", "");
                              setSuburbList([]);
                              FetchSuburbList(e);
                            }}
                            handleBlur={handleBlur}
                            className={
                              errors?.state_id &&
                              `focus-visible:ring-red-500 border-red-500`
                            }
                            disabled={false}
                            initialValue={values?.state_id}
                          />
                          {stateLoading && (
                            <span className="absolute top-2 right-2 animate-spin">
                              <Loader2 width={20} height={20} />
                            </span>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="grid md:grid-cols-2 gap-4">
                    <div className="grid gap-2">
                      <div className="min-w-0">
                        <Label htmlFor="suburb_id">
                          <CustomLabelText
                            required={true}
                            labelText="Suburb"
                            errorField={errors?.suburb_id}
                          />
                        </Label>
                        <div className="relative mt-2">
                          <SuburbSelect
                            state_id={values?.state_id} // Pass the selected state ID
                            frameworkData={suburbListing} // List of suburbs
                            loading={suburbLoading}
                            onClear={() => {
                              setFieldValue("suburb_id", "");
                            }}
                            optionType="Suburb"
                            handleSelect={(e) => {
                              setFieldValue("suburb_id", e);
                            }}
                            name="suburb_id"
                            handleBlur={handleBlur}
                            className={
                              errors?.suburb_id &&
                              `focus-visible:ring-red-500 border-red-500`
                            }
                            disabled={values?.state_id ? false : true}
                            initialValue={values?.suburb_id}
                            setSuburbList={setSuburbList} // Update suburb list as new data loads
                            setSuburbLoading={setSuburbLoading} // Control loading state
                          />
                          {suburbLoading && (
                            <span className="absolute top-2 right-2 animate-spin">
                              <Loader2 width={20} height={20} />
                            </span>
                          )}
                        </div>
                      </div>
                    </div>
                    <div className="grid gap-2">
                      <Label htmlFor="postal_code">
                        <CustomLabelText
                          required={true}
                          labelText="Postal Code"
                          errorField={errors?.postal_code}
                        />
                      </Label>
                      <PostalCodeInput
                        id="postal_code"
                        placeholder="Enter Postal Code"
                        required={true}
                        name="postal_code"
                        handleChange={(e) => {
                          setFieldValue("postal_code", e);
                        }}
                        handleBlur={handleBlur}
                        className="justify-start"
                        inputClassName={
                          errors?.postal_code &&
                          `focus-visible:ring-red-500 border-red-500`
                        }
                        value={values?.postal_code ? values?.postal_code : ""}
                      />
                    </div>
                  </div>
                </div>
              </div>
              <hr className="hr-content mt-4" />

              <div className="grid gap-4 pt-4">
                <CardTitle className="text-md">
                  Trust Bank Account Details
                </CardTitle>
                <div className="grid lg:grid-cols-2 grid-cols-1 gap-4">
                  <div className="grid md:grid-cols-2 gap-4">
                    <div className="grid gap-2">
                      <div className="min-w-0">
                        <Label htmlFor="trust_id">
                          <CustomLabelText
                            required={false}
                            labelText="Use Existing Trust Bank"
                            errorField={errors?.bank_id}
                          />
                        </Label>
                        <div className="relative mt-2">
                          <TrustSelect
                            orgId={orgId}
                            frameworkData={trustListing} // List of vendors
                            optionType="Trust"
                            handleBlur={handleBlur}
                            handleSelect={(e) => {
                              setFieldValue("trust_id", e);
                              let trustBank = trustListing?.find(
                                (item) => item?.id === e
                              );
                              setFieldValue("bank_id", trustBank?.bank_id);
                              setFieldValue(
                                "account_name",
                                trustBank?.account_name
                              );
                              setFieldValue("bsb", trustBank?.bsb);
                              setFieldValue(
                                "account_number",
                                trustBank?.account_number
                              );
                              setFieldValue("apca_id", trustBank?.apca_id);
                              setFieldValue(
                                "opening_balance",
                                trustBank?.opening_balance
                              );
                            }}
                            name="trust_id"
                            disabled={orgId ? false : true}
                            initialValue={
                              values?.trust_id ? values?.trust_id : ""
                            }
                            setTrustList={setTrustList} // Update vendor list as new data loads
                            setTrustLoading={setTrustLoading} // Control loading state
                            onClear={() => {
                              setFieldValue("trust_id", "");
                              setFieldValue("bank_id", "");
                              setFieldValue("account_name", "");
                              setFieldValue("bsb", "");
                              setFieldValue("account_number", "");
                              setFieldValue("apca_id", "");
                              setFieldValue("opening_balance", "");
                            }}
                            loading={trustLoading}
                          />
                          {bankLoading && (
                            <span className="absolute top-2 right-2 animate-spin">
                              <Loader2 width={20} height={20} />
                            </span>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="flex items-center justify-center gap-4 my-4">
                  <hr class="flex-grow border-t border-gray-300" />
                  <span class="text-gray-500 text-sm">OR</span>
                  <hr class="flex-grow border-t border-gray-300" />
                </div>
                <div className="grid lg:grid-cols-2 grid-cols-1 gap-4">
                  <div className="grid md:grid-cols-2 gap-4">
                    <div className="grid gap-2">
                      <div className="min-w-0">
                        <Label htmlFor="bank_id">
                          <CustomLabelText
                            required={true}
                            labelText="Bank Name"
                            errorField={errors?.bank_id}
                          />
                        </Label>
                        <div className="relative mt-2">
                          <SearchSelect
                            frameworks={bankListing}
                            optionType={"Bank"}
                            handleSelect={(e) => {
                              setFieldValue("bank_id", e);
                            }}
                            handleBlur={handleBlur}
                            className={
                              errors?.bank_id &&
                              `focus-visible:ring-red-500 border-red-500`
                            }
                            disabled={values?.trust_id ? true : false}
                            initialValue={values?.bank_id}
                          />
                          {bankLoading && (
                            <span className="absolute top-2 right-2 animate-spin">
                              <Loader2 width={20} height={20} />
                            </span>
                          )}
                        </div>
                      </div>
                    </div>

                    <div className="grid gap-2">
                      <Label htmlFor="account_name">
                        <CustomLabelText
                          required={true}
                          labelText="Bank Account Name"
                          errorField={errors?.account_name}
                        />
                      </Label>
                      <Input
                        type="text"
                        name="account_name"
                        value={values?.account_name ? values?.account_name : ""}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        autoComplete="off"
                        onKeyPress={(e) => {
                          e.which === 13 && e.preventDefault();
                        }}
                        disabled={values?.trust_id ? true : false}
                        className={
                          errors?.account_name &&
                          `focus-visible:ring-red-500 border-red-500`
                        }
                      />
                    </div>
                  </div>
                  <div className="grid md:grid-cols-2 gap-4">
                    <div className="grid gap-2">
                      <Label htmlFor="bsb">
                        <CustomLabelText
                          required={true}
                          labelText="BSB"
                          errorField={errors?.bsb}
                        />
                      </Label>
                      <ReactInputMask
                        id="bsb"
                        type="text"
                        name="bsb"
                        value={values?.bsb ? values?.bsb : ""}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        mask="999-999"
                        maskChar={null}
                        autoComplete="off"
                        onKeyPress={(e) => {
                          e.which === 13 && e.preventDefault();
                        }}
                        disabled={values?.trust_id ? true : false}
                        className={
                          errors?.bsb
                            ? `${cn(
                                "flex h-9 w-full rounded-md border border-input bg-transparent px-3 py-1 text-sm shadow-sm transition-colors file:border-0 file:bg-transparent file:text-sm file:font-medium placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-webPrimary dark:focus-visible:ring-ring disabled:cursor-not-allowed disabled:opacity-50"
                              )} focus-visible:ring-red-500 border-red-500`
                            : cn(
                                "flex h-9 w-full rounded-md border border-input bg-transparent px-3 py-1 text-sm shadow-sm transition-colors file:border-0 file:bg-transparent file:text-sm file:font-medium placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-webPrimary dark:focus-visible:ring-ring disabled:cursor-not-allowed disabled:opacity-50"
                              )
                        }
                      />
                    </div>
                    <div className="grid gap-2">
                      <Label htmlFor="account_number">
                        <CustomLabelText
                          required={true}
                          labelText="Account Number"
                          errorField={errors?.account_number}
                        />
                      </Label>
                      <ReactInputMask
                        id="account_number"
                        type="text"
                        name="account_number"
                        value={
                          values?.account_number ? values?.account_number : ""
                        }
                        onChange={handleChange}
                        onBlur={handleBlur}
                        mask="999999999"
                        maskChar={null}
                        autoComplete="off"
                        onKeyPress={(e) => {
                          e.which === 13 && e.preventDefault();
                        }}
                        disabled={values?.trust_id ? true : false}
                        className={
                          errors?.account_number
                            ? `${cn(
                                "flex h-9 w-full rounded-md border border-input bg-transparent px-3 py-1 text-sm shadow-sm transition-colors file:border-0 file:bg-transparent file:text-sm file:font-medium placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-webPrimary dark:focus-visible:ring-ring disabled:cursor-not-allowed disabled:opacity-50"
                              )} focus-visible:ring-red-500 border-red-500`
                            : cn(
                                "flex h-9 w-full rounded-md border border-input bg-transparent px-3 py-1 text-sm shadow-sm transition-colors file:border-0 file:bg-transparent file:text-sm file:font-medium placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-webPrimary dark:focus-visible:ring-ring disabled:cursor-not-allowed disabled:opacity-50"
                              )
                        }
                      />
                    </div>
                  </div>
                  <div className="grid md:grid-cols-2 gap-4 items-baseline">
                    <div className="grid gap-2">
                      <Label
                        htmlFor="apca_id"
                        className="flex items-center gap-2"
                      >
                        {!values?.trust_id && (
                          <div className="apca-info">
                            <DropdownMenu>
                              <DropdownMenuTrigger asChild>
                                <Button
                                  size="icon"
                                  className="rounded-full h-4 w-4"
                                >
                                  <LucideInfo className="h-4 w-4" />
                                  <span className="sr-only">APCA ID Info</span>
                                </Button>
                              </DropdownMenuTrigger>
                              <DropdownMenuContent align="start">
                                <DropdownMenuItem
                                  onClick={() => {
                                    setFieldValue(`apca_id`, "000000");
                                  }}
                                >
                                  ANZ - 000000
                                </DropdownMenuItem>
                                <DropdownMenuItem
                                  onClick={() => {
                                    setFieldValue(`apca_id`, "000000");
                                  }}
                                >
                                  Westpac - 000000
                                </DropdownMenuItem>
                                <DropdownMenuItem
                                  onClick={() => {
                                    setFieldValue(`apca_id`, "000000");
                                  }}
                                >
                                  NAB - 000000
                                </DropdownMenuItem>
                                <DropdownMenuItem
                                  onClick={() => {
                                    setFieldValue(`apca_id`, "301500");
                                  }}
                                >
                                  CBA - 301500
                                </DropdownMenuItem>
                                <DropdownMenuItem
                                  onClick={() => {
                                    setFieldValue(`apca_id`, "651966");
                                  }}
                                >
                                  BBL - 651966
                                </DropdownMenuItem>
                              </DropdownMenuContent>
                            </DropdownMenu>
                          </div>
                        )}
                        <CustomLabelText
                          required={false}
                          labelText="APCA ID"
                          errorField={errors?.apca_id}
                        />
                      </Label>
                      <ReactInputMask
                        mask="999999"
                        id="apca_id"
                        name="apca_id"
                        value={
                          values?.apca_id?.toString() ? values?.apca_id : ""
                        }
                        placeholder="APCA ID"
                        maskChar=""
                        onChange={(e) => {
                          setFieldValue(
                            `apca_id`,
                            e?.target?.value ? e?.target?.value : ""
                          );
                        }}
                        onBlur={(e) => {
                          setFieldValue(
                            `apca_id`,
                            e?.target?.value
                              ? padWithLeadingZeros(e?.target?.value, 6)
                              : ""
                          );
                        }}
                        disabled={values?.trust_id ? true : false}
                        className={
                          errors?.apca_id
                            ? `${cn(
                                "flex h-9 w-full rounded-md border border-input bg-transparent px-3 py-1 text-sm shadow-sm transition-colors file:border-0 file:bg-transparent file:text-sm file:font-medium placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-webPrimary dark:focus-visible:ring-ring disabled:cursor-not-allowed disabled:opacity-50"
                              )} focus-visible:ring-red-500 border-red-500`
                            : cn(
                                "flex h-9 w-full rounded-md border border-input bg-transparent px-3 py-1 text-sm shadow-sm transition-colors file:border-0 file:bg-transparent file:text-sm file:font-medium placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-webPrimary dark:focus-visible:ring-ring disabled:cursor-not-allowed disabled:opacity-50"
                              )
                        }
                      />
                    </div>
                    <div className="grid gap-1">
                      <CustomLabelText
                        required={false}
                        labelText="Transaction Start Date"
                        errorField={errors?.transaction_start_date}
                      />
                      <DateInputPicker
                        date={
                          values?.transaction_start_date
                            ? values?.transaction_start_date
                            : ""
                        }
                        onSelect={(e) => {
                          setFieldValue("transaction_start_date", e);
                        }}
                        className={""}
                        inputClassName="w-full"
                        disabledDate={{ after: new Date() }}
                      />
                    </div>
                    
                  </div>
                  <div className="grid md:grid-cols-2 gap-4">
                    <div className="grid gap-2">
                      <Label htmlFor="opening_balance">
                        <CustomLabelText
                          required={false}
                          labelText="Opening Balance($)"
                          errorField={errors?.opening_balance}
                        />
                      </Label>

                      <NumericFormat
                        type="text"
                        name="opening_balance"
                        value={values?.opening_balance}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        decimalScale={2}
                        allowNegative={false}
                        thousandSeparator={true}
                        isAllowed={(values) => MaxLimit(values)}
                        autoComplete="off"
                        onKeyPress={(e) => {
                          e.which === 13 && e.preventDefault();
                        }}
                        disabled={values?.trust_id ? true : false}
                        className={
                          errors?.opening_balance
                            ? `${cn(
                                "flex h-9 w-full rounded-md border border-input bg-transparent px-3 py-1 text-sm shadow-sm transition-colors file:border-0 file:bg-transparent file:text-sm file:font-medium placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-webPrimary dark:focus-visible:ring-ring disabled:cursor-not-allowed disabled:opacity-50"
                              )} focus-visible:ring-red-500 border-red-500`
                            : cn(
                                "flex h-9 w-full rounded-md border border-input bg-transparent px-3 py-1 text-sm shadow-sm transition-colors file:border-0 file:bg-transparent file:text-sm file:font-medium placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-webPrimary dark:focus-visible:ring-ring disabled:cursor-not-allowed disabled:opacity-50"
                              )
                        }
                      />
                    </div>
                  </div>
                </div>
              </div>

              {InvoiceModuleConditon(organizationData) ? (
                <div className="grid gap-4 pt-4">
                  <CardTitle className="text-md">
                    <div className="flex w-full items-center justify-between">
                      <div>Buyer's Premium</div>
                      <Switch
                        name="is_premium"
                        checked={values?.is_premium}
                        onCheckedChange={(checked) =>
                          setFieldValue("is_premium", checked)
                        }
                        onBlur={handleBlur}
                      />
                    </div>
                  </CardTitle>
                  <FieldArray name="premiums">
                    {({ push, remove }) => (
                      <div className="grid gap-6">
                        {values.premiums.map((item, index) => (
                          <div
                            key={index}
                            className="grid lg:grid-cols-4 grid-cols-2 gap-4 border rounded-xl p-4 relative"
                          >
                            <div className="grid gap-2">
                              <Label htmlFor={`premiums.${index}.code`}>
                                <CustomLabelText
                                  required={true}
                                  labelText="Code"
                                  errorField={errors?.premiums?.[index]?.code}
                                />
                              </Label>
                              <Input
                                id={`premiums.${index}.code`}
                                name={`premiums.${index}.code`}
                                placeholder="Enter Code"
                                value={values?.premiums?.[index]?.code}
                                onChange={handleChange}
                                disabled={values?.premiums?.[index]?.is_used}
                                onBlur={handleBlur}
                                className={
                                  errors?.premiums?.[index]?.code &&
                                  "focus-visible:ring-red-500 border-red-500"
                                }
                              />
                            </div>

                            <div className="grid gap-2">
                              <Label htmlFor={`premiums.${index}.premium_type`}>
                                <CustomLabelText
                                  required={true}
                                  labelText="Buyer's Premium Type"
                                  errorField={
                                    errors?.premiums?.[index]?.premium_type
                                  }
                                />
                              </Label>
                              <SearchSelect
                                frameworks={premiumTypeList}
                                optionType={"Buyer's Premium Type"}
                                handleSelect={(e) => {
                                  setFieldValue(
                                    `premiums.${index}.premium_type`,
                                    e
                                  );
                                }}
                                handleBlur={handleBlur}
                                disabled={values?.premiums?.[index]?.is_used}
                                initialValue={
                                  values?.premiums?.[index]?.premium_type
                                }
                                className={
                                  errors?.premiums?.[index]?.premium_type &&
                                  "focus-visible:ring-red-500 border-red-500"
                                }
                              />
                            </div>

                            <div className="grid gap-2">
                              <Label htmlFor={`premiums.${index}.amount`}>
                                <CustomLabelText
                                  required={true}
                                  labelText="Amount"
                                  errorField={errors?.premiums?.[index]?.amount}
                                />
                              </Label>
                              <NumericFormat
                                type="text"
                                name={`premiums.${index}.amount`}
                                value={values?.premiums?.[index]?.amount}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                decimalScale={2}
                                disabled={values?.premiums?.[index]?.is_used}
                                allowNegative={false}
                                placeholder="Enter Amount"
                                thousandSeparator={true}
                                isAllowed={(values) => MaxLimit(values)}
                                autoComplete="off"
                                onKeyPress={(e) => {
                                  e.which === 13 && e.preventDefault();
                                }}
                                className={
                                  errors?.premiums?.[index]?.amount
                                    ? "flex h-9 w-full rounded-md border border-input bg-transparent px-3 py-1 text-sm shadow-sm disabled:cursor-not-allowed disabled:opacity-50 focus-visible:ring-red-500 border-red-500"
                                    : "flex h-9 w-full rounded-md border border-input bg-transparent px-3 py-1 text-sm shadow-sm disabled:cursor-not-allowed disabled:opacity-50"
                                }
                              />
                            </div>
                            <div className="flex gap-2 items-center mt-4">
                              {index + 1 === values?.premiums?.length ? (
                                <>
                                  <Button
                                    type="button"
                                    className="h-fit w-fit p-1 "
                                    onClick={() =>
                                      push({
                                        code: "",
                                        premium_type: "",
                                        amount: "",
                                      })
                                    }
                                  >
                                    <Plus size={20} />
                                  </Button>{" "}
                                  {!values?.premiums?.[index]?.is_used && (
                                    <>
                                      <Button
                                        type="button"
                                        className="h-fit w-fit p-1 bg-red-500"
                                        onClick={() => remove(index)}
                                      >
                                        <Trash2 size={20} />
                                      </Button>
                                    </>
                                  )}
                                </>
                              ) : (
                                !values?.premiums?.[index]?.is_used && (
                                  <>
                                    <Button
                                      type="button"
                                      className="h-fit w-fit p-1 bg-red-500"
                                      onClick={() => remove(index)}
                                    >
                                      <Trash2 size={20} />
                                    </Button>
                                  </>
                                )
                              )}
                            </div>
                          </div>
                        ))}
                        {values?.premiums?.length === 0 && (
                          <Button
                            type="button"
                            // variant="secondary"
                            onClick={() =>
                              push({
                                code: "",
                                premium_type: "",
                                amount: "",
                              })
                            }
                          >
                            + Add Buyer's Premium
                          </Button>
                        )}
                      </div>
                    )}
                  </FieldArray>
                </div>
              ) : (
                <></>
              )}

              <div className="grid gap-4 pt-4">
                <CardTitle className="text-md">
                  <div className="flex w-full items-center justify-between">
                    <div>Commission</div>
                    <Switch
                      name="is_commission"
                      checked={values?.is_commission}
                      onCheckedChange={(checked) =>
                        setFieldValue("is_commission", checked)
                      }
                      onBlur={handleBlur}
                    />
                  </div>
                </CardTitle>
                <FieldArray name="commissions">
                  {({ push, remove }) => (
                    <div className="grid gap-6">
                      {values.commissions.map((item, index) => (
                        <div
                          key={index}
                          className="grid lg:grid-cols-4 grid-cols-2 gap-4 border rounded-xl p-4 relative"
                        >
                          <div className="grid gap-2">
                            <Label htmlFor={`commissions.${index}.code`}>
                              <CustomLabelText
                                required={true}
                                labelText="Code"
                                errorField={errors?.commissions?.[index]?.code}
                              />
                            </Label>
                            <Input
                              id={`commissions.${index}.code`}
                              name={`commissions.${index}.code`}
                              placeholder="Enter Code"
                              value={values?.commissions?.[index]?.code}
                              disabled={values?.commissions?.[index]?.is_used}
                              onChange={handleChange}
                              onBlur={handleBlur}
                              className={
                                errors?.commissions?.[index]?.code &&
                                "focus-visible:ring-red-500 border-red-500"
                              }
                            />
                          </div>
                          <div className="grid gap-2">
                            <Label
                              htmlFor={`commissions.${index}.commission_type`}
                            >
                              <CustomLabelText
                                required={true}
                                labelText="Commission Type"
                                errorField={
                                  errors?.commissions?.[index]?.commission_type
                                }
                              />
                            </Label>
                            <SearchSelect
                              frameworks={premiumTypeList}
                              optionType={"Commission Type"}
                              handleSelect={(e) => {
                                setFieldValue(
                                  `commissions.${index}.commission_type`,
                                  e
                                );
                              }}
                              handleBlur={handleBlur}
                              disabled={values?.commissions?.[index]?.is_used}
                              initialValue={
                                values?.commissions?.[index]?.commission_type
                              }
                              className={
                                errors?.commissions?.[index]?.commission_type &&
                                "focus-visible:ring-red-500 border-red-500"
                              }
                            />
                          </div>
                          <div className="grid gap-2">
                            <Label htmlFor={`commissions.${index}.amount`}>
                              <CustomLabelText
                                required={true}
                                labelText="Amount"
                                errorField={
                                  errors?.commissions?.[index]?.amount
                                }
                              />
                            </Label>
                            <NumericFormat
                              type="text"
                              name={`commissions.${index}.amount`}
                              value={values?.commissions?.[index]?.amount}
                              onChange={handleChange}
                              onBlur={handleBlur}
                              decimalScale={2}
                              allowNegative={false}
                              placeholder="Enter Amount"
                              disabled={values?.commissions?.[index]?.is_used}
                              thousandSeparator={true}
                              isAllowed={(values) => MaxLimit(values)}
                              autoComplete="off"
                              onKeyPress={(e) => {
                                e.which === 13 && e.preventDefault();
                              }}
                              className={
                                errors?.commissions?.[index]?.amount
                                  ? "flex h-9 w-full rounded-md border border-input bg-transparent px-3 py-1 text-sm shadow-sm disabled:cursor-not-allowed disabled:opacity-50 focus-visible:ring-red-500 border-red-500"
                                  : "flex h-9 w-full rounded-md border border-input bg-transparent px-3 py-1 text-sm shadow-sm disabled:cursor-not-allowed disabled:opacity-50"
                              }
                            />
                          </div>
                          <div className="flex gap-2 items-center mt-4">
                            {index + 1 === values?.commissions?.length ? (
                              <>
                                <Button
                                  type="button"
                                  className="h-fit w-fit p-1 "
                                  onClick={() =>
                                    push({
                                      code: "",
                                      commission_type: "",
                                      amount: "",
                                    })
                                  }
                                >
                                  <Plus size={20} />
                                </Button>{" "}
                                {!values?.commissions?.[index]?.is_used && (
                                  <>
                                    <Button
                                      type="button"
                                      className="h-fit w-fit p-1 bg-red-500"
                                      onClick={() => remove(index)}
                                    >
                                      <Trash2 size={20} />
                                    </Button>
                                  </>
                                )}
                              </>
                            ) : (
                              !values?.commissions?.[index]?.is_used && (
                                <>
                                  <Button
                                    type="button"
                                    className="h-fit w-fit p-1 bg-red-500"
                                    onClick={() => remove(index)}
                                  >
                                    <Trash2 size={20} />
                                  </Button>
                                </>
                              )
                            )}
                          </div>
                        </div>
                      ))}
                      {values?.commissions?.length === 0 && (
                        <Button
                          type="button"
                          // variant="secondary"
                          onClick={() =>
                            push({
                              code: "",
                              commission_type: "",
                              amount: "",
                            })
                          }
                        >
                          + Add Commission
                        </Button>
                      )}
                    </div>
                  )}
                </FieldArray>
              </div>
            </div>

            <div className="modal-footer pt-4 border-t mt-4 flex items-center justify-end">
              <Button type="submit" disabled={!isValid}>
                Save
              </Button>
              {!tab && (
                <Button
                  className="reset ml-3"
                  data-dismiss="modal"
                  aria-label="Close"
                  onClick={(e) => {
                    e.preventDefault();
                    toggleShowAddEditTrust();
                  }}
                  variant="secondary"
                >
                  Cancel
                </Button>
              )}
            </div>
          </form>
        </>
      )}
    </Formik>
  );
};

export default AddEditTrust;
